export default "__VITE_ASSET__CUTcZWPG__"